import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-investment-team',
  templateUrl: './investment-team.component.html',
  styleUrls: ['./investment-team.component.css']
})
export class InvestmentTeamComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
